import * as AlfredoStyles from "../../../styles/global/global";
import * as AlfredoComponents from "../../../components";

const MaterialsReport: React.FC = () => {
  return (
    <AlfredoStyles.Container>
      <AlfredoComponents.Breadcrumb />
      <AlfredoStyles.FlexContainer>
        <AlfredoStyles.FlexItem>
          <AlfredoComponents.SupplyReport />
        </AlfredoStyles.FlexItem>
      </AlfredoStyles.FlexContainer>
    </AlfredoStyles.Container>
  );
};

export default MaterialsReport;
